import { AttachmentType } from "@/api";
import { getAttachmentFileType } from "@/components/shared/attachment-file-type-registry";
import { countsAgainstDirectDocumentBudget } from "@/components/shared/direct-document-budget";
import {
    parseAuiAttachmentId,
    toAttachmentType,
} from "@/components/shared/user-message-attachment.utils";

interface StagedAttachment {
    id: string;
    type: string;
}

/**
 * Document ids staged in the composer that draw on the direct-document budget.
 *
 * Non-document attachments never counted, and spreadsheets are exempt the same
 * way the server exempts them, so both are dropped here rather than at each
 * call site. `file_type` rides the id-keyed registry because assistant-ui's
 * attachment shape has no slot for it.
 */
export function stagedCountedDocumentIds(
    attachments: readonly StagedAttachment[] | undefined
): number[] {
    const ids = new Set<number>();
    for (const attachment of attachments ?? []) {
        if (toAttachmentType(attachment.type) !== AttachmentType.Document) {
            continue;
        }
        if (
            !countsAgainstDirectDocumentBudget(
                getAttachmentFileType(attachment.id)
            )
        ) {
            continue;
        }
        const documentId = parseAuiAttachmentId(attachment.id);
        if (documentId > 0) {
            ids.add(documentId);
        }
    }
    return [...ids];
}
